module.exports = __webpack_public_path__ + "img/1.81aca56f.png";